<div class="statement">
  <div class="statement-notes service-card">
    <div class="s-card-header ">
      <span class="flex-between-start flex-column">
        {{'invoice.invoice'|translate}}
      </span>
    </div>


    <table class="table m-0">
      <thead>
        <tr>
          <th class="p-2">{{'invoice.invoice'|translate}}</th>
          <th class="p-2">{{'order-name'|translate}}</th>
          <th class="p-2">{{'invoice.vehicle'|translate}}</th>
          <th class="p-2">{{'invoice-date'|translate}}</th>
          <th class="p-2 text-right">{{'invoice-amount'|translate}}</th>
          <th class="p-2 text-right">{{'paid-to-date'|translate}}</th>
          <th class="p-2 text-right">{{'balance-due'|translate}}</th>
        </tr>
      </thead>
      <tbody class="statement-service">
        <tr *ngFor="let item of statementList; let itemIndex = index">
          <td class="p-2 name">
            <a download rel="noopener noreferrer" target="_blank" class="font-blue font-bold"
              [href]="invoiceLinks[item?._id]">
              {{item?.invCode}}
            </a>
          </td>
          <td class="p-2 description">{{item?.title}}</td>
          <td class="p-2 price">{{item?.vehicleName }}</td>
          <td class="p-2 quantity">{{ item?.invoiceDate}}</td>
          <td class="p-2 total">{{item?.totalValue || 0 | currency: usd }}</td>
          <td class="p-2 total">{{item?.paid || 0 | currency: usd }}</td>
          <td class="p-2 total">{{item?.balanceDue || 0 | currency: usd }}</td>
        </tr>
      </tbody>
      <tbody class="s-card-footer statement-service border-0">
        <tr>
          <td class="p-2 font-bold name" colspan="4">{{'total'|translate}}</td>
          <td class="p-2 font-bold total">{{statementTotal?.total || 0 | currency: usd }}</td>
          <td class="p-2 font-bold total">{{statementTotal?.paid || 0 | currency: usd }}</td>
          <td class="p-2 font-bold total">{{statementTotal?.due || 0 | currency: usd }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>